
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "marketplace-storefront-public-ui",
  currentProjectVersion: "static-1.13560",
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13560",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1207",
  "client-types": "static-1.512",
  "data-fetching-client": "static-1.10147",
  "foundations-components": "static-1.8802",
  "foundations-components-legacy": "static-1.1827",
  "foundations-theming": "static-1.5001",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.95",
  "head-dlb": "static-1.5330",
  "hs-test-utils": "static-1.8549",
  "hub-http-shared-msw-handlers": "static-1.10958",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11998",
  "I18n": "static-7.1717",
  "jasmine-runner": "static-1.6963",
  "marketplace-discovery-studio-lib": "static-1.959",
  "marketplace-storefront-base": "static-1.13623",
  "quartz": "static-1.7700",
  "react-dlb": "static-1.96",
  "react-rhumb": "static-1.17245",
  "reactive-variable-buffer-atom": "static-1.3357",
  "reporting-testing-lib": "static-1.11440",
  "reselect": "static-3.18",
  "settings-ui-lib": "static-1.13038",
  "SharedI18nStrings": "static-1.190",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7900",
  "ui-addon-i18n": "static-1.11655",
  "ui-addon-react-router-dom": "static-1.10035",
  "unified-auth": "static-1.1321",
  "unified-auth-core-lib": "static-1.1603",
  "usage-tracker": "static-1.7828",
  "usage-tracker-core": "static-1.7678",
  "customer-data-property-utils": "static-1.8563",
  "hub-http": "static-1.6712",
  "integrations-lib": "static-1.17499",
  "marketplace-ui-common": "static-1.21101",
  "marketplace-ui-install": "static-1.1087",
  "property-management-iframe": "static-1.14540",
  "quartz-config": "static-1.1478",
  "quartz-core": "static-1.6919",
  "quartz-routing": "static-1.1130",
  "quick-fetch": "static-1.4249",
  "react": "static-7.204",
  "rpc-client-utils": "static-1.5172",
  "ts-schema": "static-1.4413",
  "ui-universal-auth": "static-1.9807",
  "UIComponents": "static-3.8944",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.523",
  "hs-promise-rejection-tracking": "static-1.6078",
  "PortalIdParser": "static-2.458",
  "raven": "static-3.6411",
  "raven-hubspot": "static-1.6718",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3977",
  "quartz-webpack": "static-1.3924",
  "bend-plugin-quartz-routing": "static-1.778",
  "ai-components-ui-library": "static-1.10078",
  "codemirror": "static-5.108",
  "foundations-assets": "static-1.5397",
  "pulse": "static-1.1163",
  "react-codemirror": "static-1.11150",
  "ui-extensions-preview-lib": "static-1.1043",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5071",
  "floating-ui": "static-1.70",
  "foundations-theming-specialty": "static-1.2717",
  "framer-motion": "static-1.86",
  "hs-story-utils": "static-1.9938",
  "react-aria": "static-1.79",
  "react-create-root-preference": "static-1.113",
  "react-select-plus": "static-1.120",
  "react-utils": "static-2.5684",
  "react-virtualized": "static-2.114",
  "StyleGuideUI": "static-3.520",
  "tanstack-table": "static-1.68",
  "trellis-assets": "static-1.3179",
  "ui-fonts": "static-1.1260",
  "ui-images": "static-2.1285",
  "bend-plugin-foundations-theming": "static-1.3484",
  "foundations-theming-base": "static-1.3986",
  "stylex": "static-1.48",
  "HeadJS": "static-2.830",
  "hs-test-utils-bend-plugin": "static-1.3660",
  "msw": "static-1.105",
  "msw-config": "static-1.36",
  "testing-library": "static-1.167",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4812",
  "ui-addon-video-player": "static-1.9129",
  "ai-rendering-library": "static-1.11470",
  "chirp-fetch": "static-1.2411",
  "connections-embed-lib": "static-1.1805",
  "copilot-toolkit": "static-1.12213",
  "feedback-loader": "static-1.30108",
  "laboratory-lib": "static-3.7657",
  "marketplace-embed": "static-1.23259",
  "marketplace-ui-details": "static-1.10996",
  "marketplace-ui-reviews": "static-1.21056",
  "marketplace-ui-tracking": "static-1.15271",
  "sanitize-text": "static-1.8668",
  "usage-tracker-multi": "static-1.6242",
  "usage-tracker-session-replay": "static-1.5514",
  "beacon-keepalive-queue": "static-1.209",
  "quartz-head": "static-1.1365",
  "web-vitals": "static-1.21",
  "apollo-link-hub-http": "static-2.5099",
  "immer": "static-1.107",
  "immerable": "static-1.4649",
  "highcharts": "static-8.117",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2869",
  "reporting-data": "static-1.69507",
  "cssUtils": "static-1.1132",
  "flux-actions": "static-1.383",
  "react-colorpicker": "static-2.10715",
  "react-dnd-compat": "static-1.5114",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10880",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7818",
  "icons": "static-2.710",
  "marketplace-ui-apps-core": "static-1.19633",
  "storybook-react": "static-1.46",
  "trellis-story-utils": "static-1.5005",
  "foundations-components-test-utils": "static-1.6285",
  "quartz-i18n": "static-1.1375",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.796",
  "ads-unified-auth-lib": "static-1.2199",
  "ai-mcp-auth-lib": "static-1.58",
  "custom-vendor-connection-lib": "static-1.371",
  "gemini-settings-lib": "static-1.9842",
  "google-sheets-integration-lib": "static-1.1392",
  "microsoft-drive-auth-lib": "static-1.582",
  "slack-ui-library": "static-1.10911",
  "surveymonkey-integration-lib": "static-1.903",
  "fsm": "static-1.4268",
  "customer-data-objects": "static-1.8221",
  "property-translator": "static-1.5887",
  "hs-locale-management": "static-1.421",
  "frontend-preferences-client": "static-1.8429",
  "hs-promise-utils": "static-1.6098",
  "hubspot-apollo-client": "static-1.5389",
  "integrations-error-boundary-lib": "static-1.14914",
  "integrations-tracking-lib": "static-1.6134",
  "native-integrations-shared-strings": "static-1.8268",
  "sanitize": "static-1.4976",
  "superstore": "static-1.5264",
  "ui-shepherd-react": "static-3.10792",
  "ai-settings-ui-library": "static-1.8639",
  "hub-http-janus": "static-1.914",
  "hubspotter-http": "static-1.4993",
  "immutable-less": "static-1.5161",
  "marketplace-ui-client-types": "static-1.18508",
  "nav-meta": "static-1.30871",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18570",
  "ui-product-approvals-common": "static-1.1710",
  "ai-studio-lib": "static-1.12835",
  "hubspot-prosemirror": "static-1.19342",
  "integrations-reconnect-lib": "static-1.778",
  "ui-addon-iframeable": "static-1.9587",
  "ui-addon-integrations-directory-panel": "static-2.8460",
  "ui-product-approvals": "static-1.29815",
  "ui-tool-access": "static-1.10668",
  "inbound-db-properties-service-client": "static-1.4170",
  "property-management-common": "static-1.6828",
  "opentelemetry-fe-types": "static-1.302",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.612",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.677",
  "quartz-auth": "static-1.1375",
  "quartz-test": "static-1.1375",
  "quartz-tracking": "static-1.1079",
  "trellis-components": "static-1.3198",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.582",
  "HubStyle": "static-2.12305",
  "bender-build-tools": "static-1.3622",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.24085",
  "ContentUtils": "static-1.69554",
  "customer-data-objects-ui-components": "static-1.13542",
  "sassPrefix": "static-1.393",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2060",
  "bend-plugin-pulse": "static-1.666",
  "event-emitter": "static-1.1467",
  "fast-json-patch": "static-1.76",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5935",
  "magpie-types": "static-1.5395",
  "stylex-utils": "static-1.184",
  "trellis-theming": "static-1.1530",
  "avatar-components": "static-1.2997",
  "breeze-engine-core": "static-1.1566",
  "breeze-engine-lib": "static-1.2288",
  "breeze-onboarding-components": "static-1.1140",
  "customer-data-filters-ui": "static-1.41463",
  "customer-data-reference-ui-components": "static-1.13681",
  "data-integrations-breeze": "static-1.395",
  "embedded-academy-lib": "static-1.16111",
  "ExportDialog": "static-6.10882",
  "global-styles-ai-lib": "static-1.564",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "marketplace-embed-ba": "static-1.962",
  "mermaid": "static-1.47",
  "reporting-action-components": "static-1.42478",
  "reporting-snowflake": "static-1.58123",
  "reporting-ui-components": "static-2.66776",
  "reporting-visualizations": "static-1.61581",
  "trial-components-library": "static-1.14438",
  "ui-addon-teams": "static-1.22046",
  "upgrade-components-lib": "static-1.766",
  "navigation-components": "static-1.19234",
  "nest": "static-1.744",
  "simple-logging-lib": "static-1.3557",
  "nudge-client-utils": "static-1.3471",
  "fail-safe": "static-1.456",
  "app-governance-lib": "static-1.2797",
  "developer-experience-shared-components": "static-1.11051",
  "purchase-motions-components": "static-1.6676",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10876",
  "usage-tracker-anonymous": "static-1.6245",
  "usage-tracker-public": "static-1.7639",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3793",
  "persist-promise": "static-1.4217",
  "reference-resolvers": "static-1.8694",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4425",
  "hubspot-apollo-cache": "static-1.848",
  "universal-page-editor-lib": "static-1.3524",
  "final-form": "static-1.85",
  "redux-toolkit": "static-1.84",
  "simple-data-table": "static-1.3880",
  "merchandise-lib": "static-1.288",
  "onboarding-scopes": "static-1.6959",
  "ui-addon-draggable": "static-3.5261",
  "content-assistance-lib": "static-1.8469",
  "content-media-capture": "static-1.5846",
  "customer-data-ui-utilities": "static-1.10342",
  "emoji-mart": "static-3.9",
  "file-manager-components": "static-1.24892",
  "growth-payments-core": "static-1.26561",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3390",
  "payment-link-components": "static-1.24524",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20606",
  "ui-addon-emoji-picker": "static-1.10373",
  "ui-business-units-lib": "static-1.9604",
  "video-components-external": "static-1.12502",
  "video-data-lib": "static-1.36160",
  "navigation-messaging": "static-1.8561",
  "collaboration-sidebar": "static-1.59128",
  "trellis-ext-dnd": "static-1.591",
  "crm-component-utils": "static-1.40278",
  "crm-properties-common-lib": "static-1.6405",
  "customer-data-properties": "static-1.53169",
  "external-options-client-types": "static-1.4457",
  "hs-resources": "static-1.696",
  "property-value-citations": "static-1.3783",
  "reference-resolvers-lite": "static-1.8621",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.10956",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "cms-field-types": "static-1.5321",
  "content-icons-ui": "static-1.2491",
  "atom": "static-1.5582",
  "idb-keyval": "static-1.57",
  "reactive-lib": "static-1.1230",
  "trellis-migration-context": "static-1.88",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1266",
  "breeze-artifacts-sdk": "static-1.1095",
  "breeze-assistant-components": "static-1.2573",
  "getting-started-shared-tasks": "static-1.19622",
  "onboarding-journeys-lib": "static-1.1303",
  "conversations-skeleton-state": "static-1.7624",
  "crm-message-bus": "static-1.44174",
  "customer-data-filters-ui-msw-helpers": "static-1.23898",
  "events-data-lib": "static-1.757",
  "FormUrlGenerator": "static-2.5221",
  "framework-builder-read-service-client": "static-1.4354",
  "multi-account-reference-resolvers": "static-1.1524",
  "onboarding-tours": "static-1.17439",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14823",
  "segments-client-types": "static-1.12296",
  "academy-common-lib": "static-1.15572",
  "dashboard-lib": "static-1.83388",
  "hubspot-prosemirror-plugins": "static-1.19334",
  "reporting-plugins": "static-1.11059",
  "share-with-third-party-component-lib": "static-1.9220",
  "ui-addon-draggable-compat": "static-2.4768",
  "ui-asset-management-lib": "static-1.11613",
  "user-context": "static-1.5565",
  "reporting-reports": "static-1.69183",
  "hubs-service-types": "static-1.1773",
  "purchase-motions-api": "static-1.6679",
  "salesImages": "static-1.766",
  "signup-constants": "static-1.20019",
  "nudge-custom-function-registry": "static-1.3228",
  "nudge-renderer-utils": "static-1.3547",
  "whisper-core-api": "static-1.7685",
  "bend-plugin-fail-safe": "static-1.407",
  "framework-listing-lib": "static-2.29875",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31812",
  "apps-service-types": "static-1.4117",
  "oauth-service-types": "static-1.4646",
  "signup-ui-url-generator": "static-2.8544",
  "onboarding-tours-client": "static-1.5654",
  "one-click-checkout": "static-1.788",
  "platform-infra-nav-components": "static-1.8020",
  "subscription-experience-data-types": "static-1.15482",
  "crm-record-cards-client": "static-1.143",
  "crm-record-cards-service-types": "static-1.3880",
  "framework-data-schema-resolvers": "static-1.7404",
  "location-customization-utils-lib": "static-1.10488",
  "redux-thunk": "static-2.86",
  "react-flip-move": "static-1.85",
  "ui-coaching-tips": "static-1.29615",
  "content-media-composition-data-lib": "static-1.13650",
  "fix-webm-duration": "static-1.36",
  "notification-sounds": "static-1.4936",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3983",
  "seat-types-lib": "static-1.1106",
  "ui-addon-opt": "static-4.8930",
  "commerce-tours-lib": "static-1.6909",
  "growth-onboarding-reliability": "static-1.5594",
  "sales-checkout-service-client": "static-1.4032",
  "data-token-picker": "static-1.17186",
  "FileManagerLib": "static-1.40532",
  "content-media-compositions": "static-2.17657",
  "media-bridge-lib": "static-1.19690",
  "chatspot-widget-iframe": "static-1.24076",
  "collaboration-sidebar-common": "static-1.3925",
  "marketing-platform-lib": "static-1.7414",
  "dnd-kit": "static-1.23",
  "commerce-subscription-lib": "static-1.38111",
  "crm-actions": "static-1.6899",
  "crm-cards-sdk": "static-1.45114",
  "customer-data-properties-shared-msw-handlers": "static-1.10285",
  "customer-data-tracking": "static-1.7378",
  "calling-global-api": "static-1.66315",
  "calling-internal-common": "static-1.31831",
  "calling-lifecycle-internal": "static-1.67697",
  "calling-lifecycle-messages": "static-1.59989",
  "commerce-products-lib": "static-1.10997",
  "conditional-properties-service-client": "static-1.4132",
  "crm-index-visualization-core": "static-1.4802",
  "crm-links": "static-1.6823",
  "crm-pipelines-api-client-types": "static-1.4462",
  "data-agent-utils": "static-1.983",
  "formula-editor": "static-1.15053",
  "google-libphonenumber": "static-1.52",
  "inbounddb-objects-service-types": "static-1.4533",
  "meetings-icalendar-utils-lib": "static-1.1142",
  "multi-currency-client-types": "static-1.4027",
  "object-builder-ui-client": "static-1.50122",
  "pipeline-validation-client-types": "static-1.4302",
  "react-tinymce": "static-1.56329",
  "smart-data-capture-core": "static-1.548",
  "tiered-pricing": "static-1.2338",
  "tinymce-config": "static-2.55455",
  "tinymce-plugins": "static-1.58569",
  "tinymce-themes": "static-1.57425",
  "topics-actions-lib": "static-1.695",
  "trellis-ext-i18n": "static-1.1435",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.92",
  "fdsr-migration-layer": "static-1.523",
  "breeze-sharing-core": "static-1.57",
  "restore-request-side-panel-lib": "static-1.2108",
  "growth-data-modal": "static-1.6178",
  "growth-onboarding-confetti": "static-1.3568",
  "growth-onboarding-next-action-utils": "static-1.3043",
  "onboarding-tours-utils": "static-1.1506",
  "ui-shepherd-tracker": "static-1.8173",
  "crm-index-associations-lib": "static-1.6959",
  "academy-service-client": "static-1.4202",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40391",
  "SafeStorage": "static-1.4905",
  "video-embed": "static-1.36994",
  "wootric-nps": "static-1.7316",
  "redux-actions": "static-3.76",
  "EmailSignatureEditor": "static-1.25303",
  "viral-links-lib": "static-1.7589",
  "campaign-roi-lib": "static-1.10905",
  "campaigns-utils-lib": "static-1.3762",
  "ui-addon-calendars": "static-2.5878",
  "nested-table": "static-1.733",
  "timezone-utils": "static-2.5736",
  "getting-started-shared-tasks-store": "static-1.18740",
  "customer-data-views-management": "static-1.26414",
  "framework-data-table": "static-2.12891",
  "nudge-custom-ui-functions": "static-1.1785",
  "switchboard-lib": "static-1.748",
  "access-check-ui-lib": "static-1.1948",
  "app-users-service-client": "static-1.6126",
  "app-users-service-types": "static-1.5534",
  "mini-checkout-client": "static-1.27883",
  "onboarding-utils": "static-1.5884",
  "permissions-shared-i18n-strings-fe": "static-1.2145",
  "ui-coaching-tips-shared-config": "static-1.29600",
  "checkout-sdk": "static-3.24726",
  "payment-method-components": "static-1.7350",
  "touchless-buying-components": "static-1.6594",
  "upgrade-catalog-service-types": "static-1.3902",
  "edison-service-client-types": "static-1.898",
  "framework-data-schema-quick-fetch": "static-1.7309",
  "growth-onboarding-feedback-components": "static-1.7091",
  "audio-components": "static-1.6615",
  "FileManagerImages": "static-1.38043",
  "video-components": "static-1.14504",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20551",
  "commerce-shared-components-lib": "static-1.19636",
  "commerce-tools-ui-lib": "static-1.11385",
  "crm_data": "static-4.93280",
  "crm-activity-creator-data": "static-1.47824",
  "crm-fe-perf": "static-1.23409",
  "universal-record-utils-lib": "static-1.2435",
  "calling-error-reporting": "static-1.31838",
  "shared-worker-versioning": "static-1.11550",
  "calling-usage-tracker": "static-1.7051",
  "voice-sms-access-library": "static-1.2557",
  "commerce-permissions": "static-1.1293",
  "products-iframe-lib": "static-1.8976",
  "products-ui-components-shared-msw-handlers": "static-1.11340",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.11041",
  "sales-views-client-types": "static-1.4768",
  "data-agent-kit": "static-1.970",
  "enrichment-settings-lib": "static-1.328",
  "policy-lib": "static-1.7312",
  "bark-lib": "static-1.17041",
  "browser-prettier": "static-1.11",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3538",
  "interframe": "static-3.5249",
  "tinymce-data": "static-1.41540",
  "ui-addon-sales-email": "static-1.5713",
  "layout-dnd-components": "static-1.13275",
  "layout-dnd-utils": "static-1.12250",
  "ui-brand-identity-lib": "static-1.17023",
  "NamespacedHubStyle": "static-2.9386",
  "onboarding-data-sync-lib": "static-1.2885",
  "growth-onboarding-next-action-components": "static-1.3071",
  "user-context-client": "static-1.5019",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5024",
  "outpost": "static-1.4640",
  "draft-convert": "static-2.86",
  "draft-extend": "static-3.90",
  "draft-js": "static-5.92",
  "draft-plugins": "static-2.22409",
  "sales-email-signature-service-client": "static-1.4354",
  "copilot-messaging": "static-1.2463",
  "ts-utils-lib": "static-1.662",
  "crm-export-dialog": "static-1.6787",
  "crm-index-ui-shimmer": "static-1.3059",
  "crm-view-components": "static-1.1579",
  "react-beautiful-dnd": "static-1.77",
  "customer-data-associations": "static-1.7848",
  "tasks-actions-lib": "static-1.492",
  "InboxConnectUtils": "static-4.15899",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.888",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4498",
  "company-details-components": "static-1.6717",
  "react-performance-metrics-lib": "static-1.1060",
  "pricing-pages-ui-components": "static-1.16690",
  "quote-checkout-service-types": "static-1.3969",
  "social-insights-client-types": "static-1.22985",
  "utility-belt": "static-1.3044",
  "payments-enrollment-embed-lib": "static-1.24315",
  "stripe-embedded-components": "static-1.8295",
  "customer-data-rte": "static-1.33956",
  "cv-backend-services": "static-1.1612",
  "growth-onboarding-empty-states": "static-1.6586",
  "payments-post-enroll-local-storage-lib": "static-1.5612",
  "qrcode-generator": "static-1.82",
  "quotes-client-types": "static-1.39225",
  "crm_universal": "static-1.22771",
  "customer-data-email": "static-1.18692",
  "meetings-rte-lib": "static-1.593",
  "universal-associations-select": "static-1.11606",
  "crm-object-search-query-utilities": "static-1.10514",
  "calling-orchestration-schema": "static-1.37334",
  "react-reducer-toolkit": "static-1.16722",
  "ContentData": "static-1.69629",
  "layout-data-lib": "static-1.10575",
  "meetings-connect-utils-lib": "static-1.8126",
  "company-details-service-types": "static-1.4451",
  "segments-query-core": "static-1.1938",
  "pricing-pages-api": "static-1.16555",
  "stripe-connect-js": "static-1.85",
  "draft-content-plugins": "static-1.29209",
  "sequences-lib": "static-1.8830",
  "ui-gdpr-components": "static-1.10658",
  "meetings-client-types": "static-1.4098",
  "meetings-core": "static-1.815",
  "advanced-menus-core": "static-1.15868",
  "advanced-menus-lib": "static-1.12608",
  "ui-memberships-settings-lib": "static-1.35267",
  "sequences-client-types-lib": "static-1.8687",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15867",
  "simple-menus-lib": "static-1.17384"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13560",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1207",
  "client-types": "/client-types/static-1.512",
  "data-fetching-client": "/data-fetching-client/static-1.10147",
  "foundations-components": "/foundations-components/static-1.8802",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1827",
  "foundations-theming": "/foundations-theming/static-1.5001",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.95",
  "head-dlb": "/head-dlb/static-1.5330",
  "hs-test-utils": "/hs-test-utils/static-1.8549",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10958",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11998",
  "I18n": "/I18n/static-7.1717",
  "jasmine-runner": "/jasmine-runner/static-1.6963",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.959",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13623",
  "quartz": "/quartz/static-1.7700",
  "react-dlb": "/react-dlb/static-1.96",
  "react-rhumb": "/react-rhumb/static-1.17245",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3357",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11440",
  "reselect": "/reselect/static-3.18",
  "settings-ui-lib": "/settings-ui-lib/static-1.13038",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7900",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11655",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10035",
  "unified-auth": "/unified-auth/static-1.1321",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1603",
  "usage-tracker": "/usage-tracker/static-1.7828",
  "usage-tracker-core": "/usage-tracker-core/static-1.7678",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8563",
  "hub-http": "/hub-http/static-1.6712",
  "integrations-lib": "/integrations-lib/static-1.17499",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21101",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1087",
  "property-management-iframe": "/property-management-iframe/static-1.14540",
  "quartz-config": "/quartz-config/static-1.1478",
  "quartz-core": "/quartz-core/static-1.6919",
  "quartz-routing": "/quartz-routing/static-1.1130",
  "quick-fetch": "/quick-fetch/static-1.4249",
  "react": "/react/static-7.204",
  "rpc-client-utils": "/rpc-client-utils/static-1.5172",
  "ts-schema": "/ts-schema/static-1.4413",
  "ui-universal-auth": "/ui-universal-auth/static-1.9807",
  "UIComponents": "/UIComponents/static-3.8944",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.523",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6078",
  "PortalIdParser": "/PortalIdParser/static-2.458",
  "raven": "/raven/static-3.6411",
  "raven-hubspot": "/raven-hubspot/static-1.6718",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3977",
  "quartz-webpack": "/quartz-webpack/static-1.3924",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.778",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10078",
  "codemirror": "/codemirror/static-5.108",
  "foundations-assets": "/foundations-assets/static-1.5397",
  "pulse": "/pulse/static-1.1163",
  "react-codemirror": "/react-codemirror/static-1.11150",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.1043",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5071",
  "floating-ui": "/floating-ui/static-1.70",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2717",
  "framer-motion": "/framer-motion/static-1.86",
  "hs-story-utils": "/hs-story-utils/static-1.9938",
  "react-aria": "/react-aria/static-1.79",
  "react-create-root-preference": "/react-create-root-preference/static-1.113",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-utils": "/react-utils/static-2.5684",
  "react-virtualized": "/react-virtualized/static-2.114",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "tanstack-table": "/tanstack-table/static-1.68",
  "trellis-assets": "/trellis-assets/static-1.3179",
  "ui-fonts": "/ui-fonts/static-1.1260",
  "ui-images": "/ui-images/static-2.1285",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3484",
  "foundations-theming-base": "/foundations-theming-base/static-1.3986",
  "stylex": "/stylex/static-1.48",
  "HeadJS": "/HeadJS/static-2.830",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3660",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.36",
  "testing-library": "/testing-library/static-1.167",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4812",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9129",
  "ai-rendering-library": "/ai-rendering-library/static-1.11470",
  "chirp-fetch": "/chirp-fetch/static-1.2411",
  "connections-embed-lib": "/connections-embed-lib/static-1.1805",
  "copilot-toolkit": "/copilot-toolkit/static-1.12213",
  "feedback-loader": "/feedback-loader/static-1.30108",
  "laboratory-lib": "/laboratory-lib/static-3.7657",
  "marketplace-embed": "/marketplace-embed/static-1.23259",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10996",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.21056",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15271",
  "sanitize-text": "/sanitize-text/static-1.8668",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6242",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5514",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.209",
  "quartz-head": "/quartz-head/static-1.1365",
  "web-vitals": "/web-vitals/static-1.21",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5099",
  "immer": "/immer/static-1.107",
  "immerable": "/immerable/static-1.4649",
  "highcharts": "/highcharts/static-8.117",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2869",
  "reporting-data": "/reporting-data/static-1.69507",
  "cssUtils": "/cssUtils/static-1.1132",
  "flux-actions": "/flux-actions/static-1.383",
  "react-colorpicker": "/react-colorpicker/static-2.10715",
  "react-dnd-compat": "/react-dnd-compat/static-1.5114",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10880",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7818",
  "icons": "/icons/static-2.710",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19633",
  "storybook-react": "/storybook-react/static-1.46",
  "trellis-story-utils": "/trellis-story-utils/static-1.5005",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6285",
  "quartz-i18n": "/quartz-i18n/static-1.1375",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.796",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.2199",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.58",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.371",
  "gemini-settings-lib": "/gemini-settings-lib/static-1.9842",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1392",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.582",
  "slack-ui-library": "/slack-ui-library/static-1.10911",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.903",
  "fsm": "/fsm/static-1.4268",
  "customer-data-objects": "/customer-data-objects/static-1.8221",
  "property-translator": "/property-translator/static-1.5887",
  "hs-locale-management": "/hs-locale-management/static-1.421",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8429",
  "hs-promise-utils": "/hs-promise-utils/static-1.6098",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5389",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14914",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6134",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8268",
  "sanitize": "/sanitize/static-1.4976",
  "superstore": "/superstore/static-1.5264",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10792",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8639",
  "hub-http-janus": "/hub-http-janus/static-1.914",
  "hubspotter-http": "/hubspotter-http/static-1.4993",
  "immutable-less": "/immutable-less/static-1.5161",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18508",
  "nav-meta": "/nav-meta/static-1.30871",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18570",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1710",
  "ai-studio-lib": "/ai-studio-lib/static-1.12835",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19342",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.778",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9587",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8460",
  "ui-product-approvals": "/ui-product-approvals/static-1.29815",
  "ui-tool-access": "/ui-tool-access/static-1.10668",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4170",
  "property-management-common": "/property-management-common/static-1.6828",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.302",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.612",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.677",
  "quartz-auth": "/quartz-auth/static-1.1375",
  "quartz-test": "/quartz-test/static-1.1375",
  "quartz-tracking": "/quartz-tracking/static-1.1079",
  "trellis-components": "/trellis-components/static-1.3198",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.582",
  "HubStyle": "/HubStyle/static-2.12305",
  "bender-build-tools": "/bender-build-tools/static-1.3622",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.24085",
  "ContentUtils": "/ContentUtils/static-1.69554",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13542",
  "sassPrefix": "/sassPrefix/static-1.393",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2060",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.666",
  "event-emitter": "/event-emitter/static-1.1467",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5935",
  "magpie-types": "/magpie-types/static-1.5395",
  "stylex-utils": "/stylex-utils/static-1.184",
  "trellis-theming": "/trellis-theming/static-1.1530",
  "avatar-components": "/avatar-components/static-1.2997",
  "breeze-engine-core": "/breeze-engine-core/static-1.1566",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2288",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1140",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41463",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13681",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.395",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16111",
  "ExportDialog": "/ExportDialog/static-6.10882",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.564",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.962",
  "mermaid": "/mermaid/static-1.47",
  "reporting-action-components": "/reporting-action-components/static-1.42478",
  "reporting-snowflake": "/reporting-snowflake/static-1.58123",
  "reporting-ui-components": "/reporting-ui-components/static-2.66776",
  "reporting-visualizations": "/reporting-visualizations/static-1.61581",
  "trial-components-library": "/trial-components-library/static-1.14438",
  "ui-addon-teams": "/ui-addon-teams/static-1.22046",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.766",
  "navigation-components": "/navigation-components/static-1.19234",
  "nest": "/nest/static-1.744",
  "simple-logging-lib": "/simple-logging-lib/static-1.3557",
  "nudge-client-utils": "/nudge-client-utils/static-1.3471",
  "fail-safe": "/fail-safe/static-1.456",
  "app-governance-lib": "/app-governance-lib/static-1.2797",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11051",
  "purchase-motions-components": "/purchase-motions-components/static-1.6676",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10876",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6245",
  "usage-tracker-public": "/usage-tracker-public/static-1.7639",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3793",
  "persist-promise": "/persist-promise/static-1.4217",
  "reference-resolvers": "/reference-resolvers/static-1.8694",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4425",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.848",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3524",
  "final-form": "/final-form/static-1.85",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "simple-data-table": "/simple-data-table/static-1.3880",
  "merchandise-lib": "/merchandise-lib/static-1.288",
  "onboarding-scopes": "/onboarding-scopes/static-1.6959",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5261",
  "content-assistance-lib": "/content-assistance-lib/static-1.8469",
  "content-media-capture": "/content-media-capture/static-1.5846",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10342",
  "emoji-mart": "/emoji-mart/static-3.9",
  "file-manager-components": "/file-manager-components/static-1.24892",
  "growth-payments-core": "/growth-payments-core/static-1.26561",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3390",
  "payment-link-components": "/payment-link-components/static-1.24524",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20606",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10373",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9604",
  "video-components-external": "/video-components-external/static-1.12502",
  "video-data-lib": "/video-data-lib/static-1.36160",
  "navigation-messaging": "/navigation-messaging/static-1.8561",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59128",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.591",
  "crm-component-utils": "/crm-component-utils/static-1.40278",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6405",
  "customer-data-properties": "/customer-data-properties/static-1.53169",
  "external-options-client-types": "/external-options-client-types/static-1.4457",
  "hs-resources": "/hs-resources/static-1.696",
  "property-value-citations": "/property-value-citations/static-1.3783",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8621",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10956",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "cms-field-types": "/cms-field-types/static-1.5321",
  "content-icons-ui": "/content-icons-ui/static-1.2491",
  "atom": "/atom/static-1.5582",
  "idb-keyval": "/idb-keyval/static-1.57",
  "reactive-lib": "/reactive-lib/static-1.1230",
  "trellis-migration-context": "/trellis-migration-context/static-1.88",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1266",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1095",
  "breeze-assistant-components": "/breeze-assistant-components/static-1.2573",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19622",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1303",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7624",
  "crm-message-bus": "/crm-message-bus/static-1.44174",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23898",
  "events-data-lib": "/events-data-lib/static-1.757",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5221",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4354",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1524",
  "onboarding-tours": "/onboarding-tours/static-1.17439",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14823",
  "segments-client-types": "/segments-client-types/static-1.12296",
  "academy-common-lib": "/academy-common-lib/static-1.15572",
  "dashboard-lib": "/dashboard-lib/static-1.83388",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19334",
  "reporting-plugins": "/reporting-plugins/static-1.11059",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9220",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4768",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11613",
  "user-context": "/user-context/static-1.5565",
  "reporting-reports": "/reporting-reports/static-1.69183",
  "hubs-service-types": "/hubs-service-types/static-1.1773",
  "purchase-motions-api": "/purchase-motions-api/static-1.6679",
  "salesImages": "/salesImages/static-1.766",
  "signup-constants": "/signup-constants/static-1.20019",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3228",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3547",
  "whisper-core-api": "/whisper-core-api/static-1.7685",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.407",
  "framework-listing-lib": "/framework-listing-lib/static-2.29875",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31812",
  "apps-service-types": "/apps-service-types/static-1.4117",
  "oauth-service-types": "/oauth-service-types/static-1.4646",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8544",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5654",
  "one-click-checkout": "/one-click-checkout/static-1.788",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8020",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15482",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.143",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3880",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7404",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10488",
  "redux-thunk": "/redux-thunk/static-2.86",
  "react-flip-move": "/react-flip-move/static-1.85",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29615",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13650",
  "fix-webm-duration": "/fix-webm-duration/static-1.36",
  "notification-sounds": "/notification-sounds/static-1.4936",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3983",
  "seat-types-lib": "/seat-types-lib/static-1.1106",
  "ui-addon-opt": "/ui-addon-opt/static-4.8930",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6909",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5594",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4032",
  "data-token-picker": "/data-token-picker/static-1.17186",
  "FileManagerLib": "/FileManagerLib/static-1.40532",
  "content-media-compositions": "/content-media-compositions/static-2.17657",
  "media-bridge-lib": "/media-bridge-lib/static-1.19690",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.24076",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3925",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7414",
  "dnd-kit": "/dnd-kit/static-1.23",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38111",
  "crm-actions": "/crm-actions/static-1.6899",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.45114",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10285",
  "customer-data-tracking": "/customer-data-tracking/static-1.7378",
  "calling-global-api": "/calling-global-api/static-1.66315",
  "calling-internal-common": "/calling-internal-common/static-1.31831",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67697",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59989",
  "commerce-products-lib": "/commerce-products-lib/static-1.10997",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4132",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4802",
  "crm-links": "/crm-links/static-1.6823",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4462",
  "data-agent-utils": "/data-agent-utils/static-1.983",
  "formula-editor": "/formula-editor/static-1.15053",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4533",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1142",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4027",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50122",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4302",
  "react-tinymce": "/react-tinymce/static-1.56329",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.548",
  "tiered-pricing": "/tiered-pricing/static-1.2338",
  "tinymce-config": "/tinymce-config/static-2.55455",
  "tinymce-plugins": "/tinymce-plugins/static-1.58569",
  "tinymce-themes": "/tinymce-themes/static-1.57425",
  "topics-actions-lib": "/topics-actions-lib/static-1.695",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1435",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.92",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.523",
  "breeze-sharing-core": "/breeze-sharing-core/static-1.57",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2108",
  "growth-data-modal": "/growth-data-modal/static-1.6178",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3568",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3043",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1506",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8173",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6959",
  "academy-service-client": "/academy-service-client/static-1.4202",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40391",
  "SafeStorage": "/SafeStorage/static-1.4905",
  "video-embed": "/video-embed/static-1.36994",
  "wootric-nps": "/wootric-nps/static-1.7316",
  "redux-actions": "/redux-actions/static-3.76",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25303",
  "viral-links-lib": "/viral-links-lib/static-1.7589",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10905",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3762",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5878",
  "nested-table": "/nested-table/static-1.733",
  "timezone-utils": "/timezone-utils/static-2.5736",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18740",
  "customer-data-views-management": "/customer-data-views-management/static-1.26414",
  "framework-data-table": "/framework-data-table/static-2.12891",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1785",
  "switchboard-lib": "/switchboard-lib/static-1.748",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1948",
  "app-users-service-client": "/app-users-service-client/static-1.6126",
  "app-users-service-types": "/app-users-service-types/static-1.5534",
  "mini-checkout-client": "/mini-checkout-client/static-1.27883",
  "onboarding-utils": "/onboarding-utils/static-1.5884",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2145",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29600",
  "checkout-sdk": "/checkout-sdk/static-3.24726",
  "payment-method-components": "/payment-method-components/static-1.7350",
  "touchless-buying-components": "/touchless-buying-components/static-1.6594",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3902",
  "edison-service-client-types": "/edison-service-client-types/static-1.898",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7309",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7091",
  "audio-components": "/audio-components/static-1.6615",
  "FileManagerImages": "/FileManagerImages/static-1.38043",
  "video-components": "/video-components/static-1.14504",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20551",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19636",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11385",
  "crm_data": "/crm_data/static-4.93280",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47824",
  "crm-fe-perf": "/crm-fe-perf/static-1.23409",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2435",
  "calling-error-reporting": "/calling-error-reporting/static-1.31838",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11550",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7051",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2557",
  "commerce-permissions": "/commerce-permissions/static-1.1293",
  "products-iframe-lib": "/products-iframe-lib/static-1.8976",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11340",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.11041",
  "sales-views-client-types": "/sales-views-client-types/static-1.4768",
  "data-agent-kit": "/data-agent-kit/static-1.970",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.328",
  "policy-lib": "/policy-lib/static-1.7312",
  "bark-lib": "/bark-lib/static-1.17041",
  "browser-prettier": "/browser-prettier/static-1.11",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3538",
  "interframe": "/interframe/static-3.5249",
  "tinymce-data": "/tinymce-data/static-1.41540",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5713",
  "layout-dnd-components": "/layout-dnd-components/static-1.13275",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12250",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17023",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9386",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2885",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3071",
  "user-context-client": "/user-context-client/static-1.5019",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5024",
  "outpost": "/outpost/static-1.4640",
  "draft-convert": "/draft-convert/static-2.86",
  "draft-extend": "/draft-extend/static-3.90",
  "draft-js": "/draft-js/static-5.92",
  "draft-plugins": "/draft-plugins/static-2.22409",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4354",
  "copilot-messaging": "/copilot-messaging/static-1.2463",
  "ts-utils-lib": "/ts-utils-lib/static-1.662",
  "crm-export-dialog": "/crm-export-dialog/static-1.6787",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.3059",
  "crm-view-components": "/crm-view-components/static-1.1579",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.77",
  "customer-data-associations": "/customer-data-associations/static-1.7848",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.492",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15899",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.888",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4498",
  "company-details-components": "/company-details-components/static-1.6717",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1060",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16690",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3969",
  "social-insights-client-types": "/social-insights-client-types/static-1.22985",
  "utility-belt": "/utility-belt/static-1.3044",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24315",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8295",
  "customer-data-rte": "/customer-data-rte/static-1.33956",
  "cv-backend-services": "/cv-backend-services/static-1.1612",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6586",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5612",
  "qrcode-generator": "/qrcode-generator/static-1.82",
  "quotes-client-types": "/quotes-client-types/static-1.39225",
  "crm_universal": "/crm_universal/static-1.22771",
  "customer-data-email": "/customer-data-email/static-1.18692",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.593",
  "universal-associations-select": "/universal-associations-select/static-1.11606",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10514",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37334",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16722",
  "ContentData": "/ContentData/static-1.69629",
  "layout-data-lib": "/layout-data-lib/static-1.10575",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8126",
  "company-details-service-types": "/company-details-service-types/static-1.4451",
  "segments-query-core": "/segments-query-core/static-1.1938",
  "pricing-pages-api": "/pricing-pages-api/static-1.16555",
  "stripe-connect-js": "/stripe-connect-js/static-1.85",
  "draft-content-plugins": "/draft-content-plugins/static-1.29209",
  "sequences-lib": "/sequences-lib/static-1.8830",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10658",
  "meetings-client-types": "/meetings-client-types/static-1.4098",
  "meetings-core": "/meetings-core/static-1.815",
  "advanced-menus-core": "/advanced-menus-core/static-1.15868",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12608",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35267",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8687",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15867",
  "simple-menus-lib": "/simple-menus-lib/static-1.17384"
}
};
